var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.0991801242,6.8813913 C0.0991801242,10.6134658 3.12467081,13.6389565 6.8569441,13.6389565 C10.5892174,13.6389565 13.6147081,10.6134658 13.6147081,6.8813913 C13.6147081,3.14911801 10.5892174,0.123428571 6.8569441,0.123428571 C3.12467081,0.123428571 0.0991801242,3.14911801 0.0991801242,6.8813913 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FICC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Disclaimer---language-options",
    transform: "translate(-471.000000, -244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lang",
    transform: "translate(448.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SE",
    transform: "translate(23.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.4184 12.4182,16 8,16 C3.5816,16 0,12.4184 0,8 C0,3.5818 3.5816,0 8,0 C12.4182,0 16,3.5818 16,8",
    id: "Fill-403",
    fill: "#336581"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-412",
    transform: "translate(1.142857, 1.142857)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-406"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-405",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "6.8569441 5.49008696 20.5652671 5.49008696 20.5652671 0.123627329 6.8569441 0.123627329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-407",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "-2.68342857 5.49008696 4.0743354 5.49008696 4.0743354 0.123627329 -2.68342857 0.123627329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-408",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "-2.68342857 13.6391553 4.0743354 13.6391553 4.0743354 8.27269565 -2.68342857 8.27269565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-409",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "6.8569441 13.6391553 20.5712298 13.6391553 20.5712298 8.27269565 6.8569441 8.27269565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-410",
    fill: "#F5DB16",
    mask: "url(#mask-2)",
    points: "4.0743354 13.6389565 6.8569441 13.6389565 6.8569441 0.123428571 4.0743354 0.123428571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-411",
    fill: "#F5DB16",
    mask: "url(#mask-2)",
    points: "-2.60332919 8.27269565 20.5650683 8.27269565 20.5650683 5.49008696 -2.60332919 5.49008696"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSe);
export default __webpack_public_path__ + "static/media/SE.17bc740a237743af03876db4319602e5.svg";
export { ForwardRef as ReactComponent };